import { useEffect, useState } from 'react'

import { EmailVerificationInput } from './email_verification_input'

export const EmailVerification = ({ disabled = false, handleSubmit, error, reset }) => {
  const [isVerificationCodeSent, setVerificationCodeSent] = useState(false)
  const [verificationCode, setVerificationCode] = useState('')

  useEffect(() => {
    if (!disabled) setVerificationCodeSent(false)
  }, [disabled])

  const onVerificationCodeChange = (value, isFilled) => {
    setVerificationCode(value)

    if (isFilled && !isVerificationCodeSent) {
      setVerificationCodeSent(true)
      handleSubmit({ code: value })
    } else {
      reset()
      setVerificationCodeSent(false)
    }
  }

  return (
    <EmailVerificationInput
      value={verificationCode}
      disabled={disabled}
      onFocus={reset}
      onChange={onVerificationCodeChange}
      error={error}
    />
  )
}
